module.exports = __webpack_public_path__ + "img/d-bacalhau.b0c2c944.jpg";